import { useMemo } from 'react';
import { PaybisPaymentMethod } from '../../../../../../apis/user/types';

export function usePaybisMethodOptions(methods: PaybisPaymentMethod[]) {
  return useMemo(
    () => methods?.map((x) => ({ value: x.id, label: x.displayName })),
    [methods],
  );
}

export function usePaybisCurrencyOptions() {
  return useMemo(
    () =>
      [
        'AED',
        'ARS',
        'AUD',
        'AZN',
        'BDT',
        'BGN',
        'BHD',
        'BRL',
        'CAD',
        'CHF',
        'CLP',
        'COP',
        'CRC',
        'CZK',
        'DKK',
        'DOP',
        'DZD',
        'EGP',
        'EUR',
        'GBP',
        'GEL',
        'HKD',
        'HUF',
        'IDR',
        'ILS',
        'INR',
        'ISK',
        'JPY',
        'KES',
        'KRW',
        'KWD',
        'MAD',
        'MXN',
        'MYR',
        'NGN',
        'NOK',
        'NZD',
        'PEN',
        'PHP',
        'PLN',
        'QAR',
        'RON',
        'SAR',
        'SEK',
        'SGD',
        'THB',
        'TND',
        'TRY',
        'UAH',
        'USD',
        'VND',
        'XAF',
        'XOF',
        'ZAR',
      ].map((x) => ({ value: x, label: x })),
    [],
  );
}
